import React, { useCallback, useEffect, useState } from "react";

import {
    Content,
    ContentBody,
    DialogTop,
    DialogTopLeft,
    DialogTopCenter,
    DialogTopRight,
    IconHeader,
    ContainerList,
    AutomaticData,
    SubTitle,
    Description,
    ContentDescription
} from "./style";

import { Dialog } from '@material-ui/core';
import { AiOutlineClose } from "react-icons/ai";
import { Flow } from "../../../interfaces/Flow";
import { TbExternalLink, TbRotateClockwise } from "react-icons/tb";
import api from "../../../services/api";
import { Card } from "../../../interfaces/Card";
import List from "../../../components/List";
import ListItem from "../../../components/List/ListItem";
import ListColumn from "../../../components/List/ListColumn";
import ListText from "../../../components/List/ListText";
import ListButton from "../../../components/List/ListButton";
import { useToast } from "../../../hooks/toast";

interface RecorrenceProps {
    open: boolean;
    flow: Flow;
    onClose: () => void;
}

const Recorrence: React.FC<RecorrenceProps> = ({ onClose, open, flow }) => {

    const { addToast } = useToast();

    const [loading, setLoading] = useState<boolean>(false);
    const [cards, setCards] = useState<Card[]>([]);

    const handleClose = useCallback(async () => {
        onClose();
    }, [onClose]);

    const getRecurrencesFlowApi = useCallback(async () => {

        setLoading(true);

        await api.get(`/card/my-recurrences`, {
            params: {
                flow_id: flow.id_flow,
            }
        }).then(response => {
            if (response.data !== null) {
                let resp: Card[] = response.data;

                setCards(resp);
            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
            addToast({
                type: "error",
                title: "Erro ao buscar os cartões recorrêntes.",
                description: "Ao tentar buscar os cartões recorrêntes, ocorreu um erro."
            });
        });

    }, [addToast, flow.id_flow]);

    useEffect(() => {

        getRecurrencesFlowApi();

    }, [getRecurrencesFlowApi]);

    return (
        <Dialog
            fullWidth={true}
            maxWidth="lg"
            open={open}
            onClose={handleClose}
        >
            <DialogTop>
                <DialogTopLeft>
                    <IconHeader color={"gray"}>
                        <div>
                            <TbRotateClockwise />
                        </div>
                    </IconHeader>
                    <h1>
                        {"Recorrências"}
                    </h1>
                </DialogTopLeft>

                <DialogTopCenter />

                <DialogTopRight>
                    <button onClick={handleClose}><AiOutlineClose /></button>
                </DialogTopRight>
            </DialogTop>

            <Content style={{ padding: '0px' }}>
                <ContentBody container>

                    <ContentDescription>
                        <SubTitle>
                            {"Cartões recorrentes"}
                        </SubTitle>
                        <Description>
                            {"Aqui você pode visualizar os cartões que estão com a recorrência configurada e ativa no seu fluxo."}
                        </Description>
                    </ContentDescription>

                    {loading ?
                        <div>Loading...</div> :
                        <ContainerList>
                            <List style={{ border: '1px solid #f4f5f7' }}>
                                <ListItem>
                                    <ListColumn flex flexGrow={3}>
                                        <ListText header>
                                            Cartão
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn>
                                        <ListText header>
                                            Identificador
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn flex flexGrow={2}>
                                        <ListText header>
                                            Comportamento
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn flex flexGrow={2}>
                                        <ListText header>
                                            Próxima execução
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn>
                                        <ListText header>
                                            Ações
                                        </ListText>
                                    </ListColumn>
                                </ListItem>

                                {cards !== undefined && cards.length > 0 && cards.map((card, index) => {
                                    return (
                                        <ListItem key={index}>
                                            <ListColumn aglinItems="flex-start" flex flexGrow={3}>
                                                <a href={`/flow/${flow.hash}/card/${card.id_card}`} style={{ textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">
                                                    <ListText fontSize="15px" fontWeight="500">
                                                        {card.title}
                                                    </ListText>
                                                </a>
                                            </ListColumn>
                                            <ListColumn>
                                                <ListText>
                                                    <AutomaticData>{card.id_card}</AutomaticData>
                                                </ListText>
                                            </ListColumn>
                                            <ListColumn flex flexGrow={2}>
                                                <ListText>
                                                    {card.behavior === "new" ? "Cria um novo cartão" : "Retorna para a etapa inicial"}
                                                </ListText>
                                            </ListColumn>
                                            <ListColumn flex flexGrow={2}>
                                                <ListText>
                                                    {card.next_recurrence !== undefined ? new Date(card.next_recurrence).toLocaleDateString('pt-BR') : ""}
                                                </ListText>
                                            </ListColumn>
                                            <ListColumn>
                                                <ListText color="gray">
                                                    <ListButton
                                                        title={"Abrir o cartão"}
                                                        Icon={TbExternalLink}
                                                        color="transparent"
                                                        onClick={() => {
                                                            window.open(`/flow/${flow.hash}/card/${card.id_card}`, '_blank');
                                                        }}
                                                    />
                                                </ListText>
                                            </ListColumn>
                                        </ListItem>
                                    )
                                })}

                                {cards !== undefined && cards.length === 0 &&
                                    <ListItem>
                                        <ListColumn>
                                            <ListText>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px' }}>
                                                    {"Nenhum cartão recorrente encontrado. Comece a criar cartões recorrentes para visualizá-los aqui."}
                                                </div>
                                            </ListText>
                                        </ListColumn>
                                    </ListItem>
                                }
                            </List>
                        </ContainerList>
                    }

                </ContentBody>
            </Content>
        </Dialog >
    );

}

export default Recorrence;